/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Identifying_SpeakersInputs */

const en_identifying_speakers = /** @type {(inputs: Identifying_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identifying Speakers...`)
};

const fr_identifying_speakers = /** @type {(inputs: Identifying_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identification des intervenants...`)
};

const de_identifying_speakers = /** @type {(inputs: Identifying_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprecher identifizieren...`)
};

const it_identifying_speakers = /** @type {(inputs: Identifying_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identificazione dei relatori...`)
};

const ru_identifying_speakers = /** @type {(inputs: Identifying_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Идентификация говорящих...`)
};

const es_identifying_speakers = /** @type {(inputs: Identifying_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identificando a los hablantes...`)
};

const zh_cn2_identifying_speakers = /** @type {(inputs: Identifying_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`识别说话人……`)
};

const ja_identifying_speakers = /** @type {(inputs: Identifying_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`話者を識別しています...`)
};

const hi_identifying_speakers = /** @type {(inputs: Identifying_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वक्ताओं की पहचान करना...`)
};

const pt_pt2_identifying_speakers = /** @type {(inputs: Identifying_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identificando os palestrantes...`)
};

/**
* | output |
* | --- |
* | "Identifying Speakers..." |
*
* @param {Identifying_SpeakersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const identifying_speakers = /** @type {((inputs?: Identifying_SpeakersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Identifying_SpeakersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_identifying_speakers(inputs)
	if (locale === "de") return de_identifying_speakers(inputs)
	if (locale === "it") return it_identifying_speakers(inputs)
	if (locale === "ru") return ru_identifying_speakers(inputs)
	if (locale === "es") return es_identifying_speakers(inputs)
	if (locale === "zh-CN") return zh_cn2_identifying_speakers(inputs)
	if (locale === "ja") return ja_identifying_speakers(inputs)
	if (locale === "hi") return hi_identifying_speakers(inputs)
	if (locale === "pt-PT") return pt_pt2_identifying_speakers(inputs)
	return en_identifying_speakers(inputs)
});